import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import UserPhoto from '../../UserPhoto/UserPhoto';

class VinculoMembro extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.removerVinculo = this.removerVinculo.bind(this);

        this.state = {
            isOpen: true,
            isLoading: this.props.vinculo.value ? true : false,
            flagBusca: this.props.vinculo.value,
            dadosMembro: {}
        }

        this.configurations = new Configurations();

    }

    componentDidMount() {
        if (this.state.flagBusca) {
            this.setState({ isLoading: true })
            axios.get(this.configurations.apiBasePath + `/busca?query=M${this.props.vinculo.info}`)
                .then(resp => {
                    this.setState({ dadosMembro: resp.data.users[0] })
                }).finally(() => this.setState({ isLoading: false }));
        }
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    toggleCollapse() {
        if (this.state.flagBusca) this.setState({ isOpen: !this.state.isOpen })
    }

    removerVinculo() {
        this.props.remover(this.props.index);
    }

    render() {
        const {
            coordGeral, coordenadoria, sub, rm, area, regional, distrito, comunidade, bloco,
            nome, codMembro,
            // idUsuario
        } = this.state.dadosMembro;
        return (
            <div className="card rounded card-vinculo vinculo-membro">
                <div className={`card-header ${this.state.isOpen ? '' : 'rounded'}`}>
                    <div className="row no-gutters align-items-center">
                        <div className="col-10">
                            <form className="form-inline" action="" method="POST">
                                <span className="badge badge-primary mr-3">{`MEMBRO`}</span>
                                {this.state.flagBusca ? (
                                    <h5 className="m-0 font-weight-bold">{nome} ({codMembro})</h5>
                                ) : (
                                        <AsyncTypeahead
                                            id="mainSearch"
                                            isLoading={this.state.isLoading}
                                            className="ebs-typeahead w-75"
                                            onChange={(s) => {
                                                if (s && s.length > 0) {
                                                    this.setState({
                                                        isOpen: true,
                                                        dadosMembro: s[0],
                                                        flagBusca: true
                                                    }, () => {
                                                        this.props.atualizar(this.props.index, this.state.dadosMembro.idUsuario, this.state.dadosMembro.codMembro)
                                                    })
                                                }
                                            }}
                                            labelKey={(option) => {
                                                if (option) {
                                                    switch (option.type) {
                                                        case 1:
                                                            return `M${option.codMembro.toString()}`;
                                                        default:
                                                            return option.nome;
                                                    }
                                                } else {
                                                    return option;
                                                }
                                            }
                                            }
                                            renderMenuItemChildren={(option, props, idx) => (
                                                <div className="d-flex align-items-center border-bottom">
                                                    <div className="mr-2"><UserPhoto src={`${this.configurations.apiBasePath}/minhas-informacoes/foto/${option.codMembro.toString()}`}></UserPhoto></div>
                                                    <Highlighter search={props.text}>
                                                        {option.nome}
                                                    </Highlighter>
                                                    &nbsp;<small>(
                                                <Highlighter search={props.text.substr(1, props.text.length)}>
                                                            {option.codMembro ? option.codMembro.toString() : ''}
                                                        </Highlighter>)</small>
                                                    &nbsp;<span className="badge badge-info">{option.divisao}</span>
                                                    &nbsp; - {option.coordenadoria}
                                                </div>
                                            )}
                                            delay={400}
                                            emptyLabel="Nenhum resultado encontrado"
                                            searchText="Procurando..."
                                            promptText="Digite para procurar..."
                                            minLength={2}
                                            placeholder="Insira o nome ou código de membro..."
                                            onSearch={query => {
                                                this.setState({ isLoading: true });
                                                axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                                                    .then(resp => {
                                                        if (resp.data && (resp.data.orders || resp.data.users)) {
                                                            this.setState({
                                                                isLoading: false,
                                                                options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users
                                                            });
                                                        }
                                                    });
                                            }}
                                            options={this.state.options}
                                        />
                                    )}
                            </form>
                        </div>
                        <div className="col-2 text-right">
                            <i onClick={this.removerVinculo} className={`far fa-trash-alt text-danger icone-remover ${this.props.pedidoFinalizado ? 'd-none' : ''}`}></i>
                        </div>
                    </div>
                </div>
                <Collapse isOpen={this.state.isOpen}>
                    <div className="card-body p-2">
                        <div className="row no-gutters">
                            {this.state.flagBusca && (
                                <div className="col-12 py-2">
                                    {this.state.isLoading ? (
                                        <div className="row no-gutters">
                                            <div className="col-12 py-3 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                            <div className="row no-gutters">
                                                <div className="col-12 px-3">
                                                    <div className="row no-gutters align-items-center">
                                                        <div className="col-1 px-3">
                                                            <div className="profile-photo" style={{ "backgroundImage": `url(${this.configurations.apiBasePath}/minhas-informacoes/foto/${codMembro})` }} />
                                                        </div>
                                                        <div className="col-11">
                                                            <h6 className="my-0">{nome} ({codMembro})</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-1 col-11 px-3">
                                                    <div className="row">
                                                        <div className="col-3 py-1">
                                                            <small><strong>Coord. Geral:</strong> {coordGeral}</small>
                                                        </div>
                                                        <div className="col-3 py-1">
                                                            <small><strong>Coord:</strong> {coordenadoria}</small>
                                                        </div>
                                                        <div className="col-3 py-1">
                                                            <small><strong>Sub:</strong> {sub}</small>
                                                        </div>
                                                        <div className="col-3 py-1">
                                                            <small><strong>RM/RE:</strong> {rm}</small>
                                                        </div>
                                                        {area && (
                                                            <div className="col-3 py-1">
                                                                <small><strong>Área:</strong> {area}</small>
                                                            </div>
                                                        )}
                                                        {regional && (
                                                            <div className="col-3 py-1">
                                                                <small><strong>Regional:</strong> {regional}</small>
                                                            </div>
                                                        )}
                                                        <div className="col-3  py-1">
                                                            <small><strong>Distrito:</strong> {distrito}</small>
                                                        </div>
                                                        <div className="col-3  py-1">
                                                            <small><strong>Comunidade:</strong> {comunidade}</small>
                                                        </div>
                                                        <div className="col-3  py-1">
                                                            <small><strong>Bloco:</strong> {bloco}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        )}

                                </div>
                            )}

                        </div>
                    </div>
                </Collapse>
            </div>
        )
    }
}

export default VinculoMembro;